import LegalPage from "./LegalPage";

const PRIVACY_SECTIONS = [
  {
    heading: "Who we are",
    body: [
      "Bigibila Consultancy / BIGIBILA SYSTEMS™ (\"Bigibila\", \"we\", \"us\") is an Aboriginal-led governance architecture firm. This Privacy Notice describes how we handle personal information you provide to us through this website, including the Request Access form, mailing list sign-ups and any direct correspondence.",
    ],
  },
  {
    heading: "What we collect",
    body: [
      "When you contact us, we collect: your name, organisation, role, email address, phone number (if you provide one), the nature of your enquiry, and any other information you choose to send in your message.",
      "We do not knowingly collect sensitive cultural material, Indigenous knowledge, family records or community data through this website. If you wish to share such material, please contact us first so we can arrange an appropriate, custodian-respecting channel.",
    ],
  },
  {
    heading: "How we use your information",
    body: [
      "We use the information you provide only to respond to your enquiry, schedule a discovery call, and follow up on any subsequent engagement.",
      "We do not sell, rent or trade your personal information. We do not use it to train artificial intelligence systems. We do not share it with third parties except where required to deliver a service you have engaged us for, or where required by law.",
    ],
  },
  {
    heading: "Storage and retention",
    body: [
      "Contact form submissions are stored in a database under our control. We retain them only as long as needed to respond to your enquiry and any follow-on engagement. You may request deletion of your information at any time by contacting us.",
    ],
  },
  {
    heading: "Your rights",
    body: [
      "You may request a copy of the personal information we hold about you, request that it be corrected, or request that it be deleted. Contact us using the details on the Contact page to make such a request.",
    ],
  },
  {
    heading: "Questions",
    body: [
      "For any privacy questions or concerns, contact us at info@bigibilasystems.com.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Notice"
      lastUpdated="DRAFT — Feb 2026"
      sections={PRIVACY_SECTIONS}
    />
  );
}
